@let configs = lookups().configs;
<!-- Nothing at all when the organization does not use passengers; the paying passengers and the tax follow its configuration. -->
@if (configs.passengerEnabled) {
    <fieldset class="group" [formGroup]="group()">
        <legend>{{ "FLIGHT_LIST.groups.passengers" | translate }}</legend>
        <div class="fields">
            <label class="field">
                <span class="label">{{ (configs.pobEnabled ? "FLIGHT_LIST.edit.headcount.pob" : "FLIGHT_LIST.passengers") | translate }}</span>
                <kendo-numerictextbox formControlName="passengers" format="#" [decimals]="0" [min]="0" [spinners]="false"></kendo-numerictextbox>
                @if (group().controls.passengers.errors?.["minPob"]; as min) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.minPob" | translate: { min: min } }}</span>
                }
                @if (group().controls.passengers.errors?.["minPax"]; as min) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.minPax" | translate: { min: min } }}</span>
                }
            </label>
            @if (configs.payingPassengersEnabled) {
                <label class="field">
                    <span class="label">{{ "FLIGHT_LIST.payingPassengers" | translate }}</span>
                    <kendo-numerictextbox formControlName="payingPassengers" format="#" [decimals]="0" [min]="0" [spinners]="false"></kendo-numerictextbox>
                    @if (group().controls.payingPassengers.hasError("maxPax")) {
                        <span class="error">{{ "FLIGHT_LIST.edit.errors.maxPax" | translate: { max: group().controls.payingPassengers.getError("maxPax") } }}</span>
                    }
                </label>
            }
            @if (configs.taxEnabled) {
                <label class="field check">
                    <input type="checkbox" kendoCheckBox formControlName="isTax" />
                    <span class="label">{{ "FLIGHT_LIST.isTax" | translate }}</span>
                </label>
            }
        </div>
    </fieldset>
}
